<div class="" [ngClass]="{'p-3' : label}">
    <div class="flex justify-content-between" *ngIf="label">
        <h5>{{translate_service.getText('lbl_timesheets')}}</h5>
    </div>
    <hr *ngIf="label">
    <form class="grid" [formGroup]="jobs_timesheet_form">
        <div class="col-12 lg:col-12">
            <div class="grid formgrid p-fluid">
                <div class="field col-12 md:col-12">
                    <label for="multiplemonths">{{translate_service.getText('lbl_date')}}<span
                            class="asterisk">*</span></label>
                    <p-calendar #calendar [dateFormat]="shared_service.date_format_input_code" formControlName="date"
                        [placeholder]="shared_service.date_format_code" [(ngModel)]="selectedStartDate"
                        [showTime]="false" [minDate]="minSelectableDate"
                        (onShow)="adjustCalendarWithRetry(); adjustDateRange()" [disabledDates]="disabledDates"
                        [ngClass]="{'is-invalid ng-dirty': jobs_timesheet_form.get('date').invalid &&
                        (jobs_timesheet_form.get('date').dirty || jobs_timesheet_form.get('date').touched ||
                        jobs_timesheet_form.submitted)}">

                        <ng-template pTemplate="date" let-date>
                            <span class="font-medium text-900" [ngStyle]="{
              'text-decoration': isRestrictedDate(date) ? 'line-through' : 'none',
              'text-decoration-thickness': isRestrictedDate(date) ? '2px' : 'initial',
              'font-weight': isRestrictedDate(date) ? '1000 !important' : '0'
          }">
                                {{ date.day }}
                            </span>
                        </ng-template>
                    </p-calendar>

                    <span
                        *ngIf="jobs_timesheet_form.get('date').invalid && (jobs_timesheet_form.get('date').dirty || jobs_timesheet_form.get('date').touched || jobs_timesheet_form.submitted)">
                        <small class="alert-danger"
                            *ngIf="jobs_timesheet_form.get('date').errors?.required">{{translate_service.getText('message_25')}}</small>
                        <small class="alert-danger"
                            *ngIf="jobs_timesheet_form.get('date').errors?.incorrect">{{error_message}}</small>
                    </span>
                </div>
                <div class="field mb-4 col-12 md:col-12" *ngIf="label || url?.includes('clients')">
                    <label>{{translate_service.getText('lbl_staff')}}<span class="asterisk"> *</span></label>
                    <p-dropdown optionValue="user_profile_id" optionLabel="name" [options]="user_list" [filter]="true"
                        [resetFilterOnHide]="true"
                        [ngClass]="{'is-invalid':jobs_timesheet_form.get('staff_id').invalid &&  
                        (jobs_timesheet_form.get('staff_id').touched || jobs_timesheet_form.get('staff_id').dirty || jobs_timesheet_form.submitted)}"
                        formControlName="staff_id" placeholder="{{translate_service.getText('message_135')}}"
                        (onChange)="rateChange($event)"></p-dropdown>
                    <span
                        *ngIf="jobs_timesheet_form.get('staff_id').invalid && (jobs_timesheet_form.get('staff_id').dirty ||jobs_timesheet_form.get('staff_id').touched ||jobs_timesheet_form.submitted )">
                        <small class="alert-danger"
                            *ngIf="jobs_timesheet_form.get('staff_id').errors?.required">{{translate_service.getText('message_25')}}</small>
                        <small class="alert-danger"
                            *ngIf="jobs_timesheet_form.get('staff_id').errors?.incorrect">{{error_message
                            }}</small>
                    </span>
                </div>
                <div class="field mb-4 col-12 md:col-12" *ngIf="!label && !url?.includes('clients')">
                    <label>{{translate_service.getText('lbl_staff')}}<span class="asterisk"> *</span></label>
                    <p-dropdown optionValue="staff_id" optionLabel="name" [options]="user_list" [filter]="true"
                        [resetFilterOnHide]="true"
                        [ngClass]="{'is-invalid':jobs_timesheet_form.get('staff_id').invalid &&  
                        (jobs_timesheet_form.get('staff_id').touched || jobs_timesheet_form.get('staff_id').dirty || jobs_timesheet_form.submitted)}"
                        formControlName="staff_id" placeholder="{{translate_service.getText('message_135')}}"
                        (onChange)="rateChange($event)"></p-dropdown>
                    <span
                        *ngIf="jobs_timesheet_form.get('staff_id').invalid && (jobs_timesheet_form.get('staff_id').dirty ||jobs_timesheet_form.get('staff_id').touched ||jobs_timesheet_form.submitted )">
                        <small class="alert-danger"
                            *ngIf="jobs_timesheet_form.get('staff_id').errors?.required">{{translate_service.getText('message_25')}}</small>
                        <small class="alert-danger"
                            *ngIf="jobs_timesheet_form.get('staff_id').errors?.incorrect">{{error_message
                            }}</small>
                    </span>
                </div>
                <div class="field col-12 md:col-12">
                    <label for="client_id" class="font-medium text-900">{{translate_service.getText('lbl_client')}}<span
                            class="asterisk">*</span>
                    </label>
                    <p-dropdown optionValue="client_id" optionLabel="name" formControlName="client_id"
                        [options]="client_list" placeholder="{{translate_service.getText('message_119')}}"
                        [filter]="true" dropzone="true" [ngClass]="{
                            'is-invalid': jobs_timesheet_form.get('client_id').invalid && (jobs_timesheet_form.get('client_id').dirty || jobs_timesheet_form.get('client_id').touched || jobs_timesheet_form.submitted),
                            }" (onChange)="ClientChanged(true)">
                    </p-dropdown>
                    <span
                        *ngIf="jobs_timesheet_form.get('client_id').invalid && (jobs_timesheet_form.get('client_id').dirty || jobs_timesheet_form.get('client_id').touched || jobs_timesheet_form.submitted)">
                        <small class="alert-danger"
                            *ngIf="jobs_timesheet_form.get('client_id').errors?.required">{{translate_service.getText('message_25')}}</small>
                        <small class="alert-danger"
                            *ngIf="jobs_timesheet_form.get('client_id').errors?.incorrect">{{error_message}}</small>
                    </span>
                </div>
                <div class="field mb-4 col-12 md:col-12">
                    <label>{{translate_service.getText('lbl_jobs')}}<span class="asterisk"> *</span></label>
                    <p-dropdown optionValue="job_id" [resetFilterOnHide]="true" optionLabel="name" [options]="jobs_list"
                        [filter]="true"
                        [ngClass]="{'is-invalid': jobs_timesheet_form.get('job_id').invalid &&  
                        (jobs_timesheet_form.get('job_id').touched || jobs_timesheet_form.get('job_id').dirty || jobs_timesheet_form.submitted)}"
                        formControlName="job_id" placeholder="{{translate_service.getText('lbl_select_job')}}"
                        (onChange)="onChangeJob($event,true)">
                    </p-dropdown>
                    <span
                        *ngIf="jobs_timesheet_form.get('job_id').invalid && 
                        (jobs_timesheet_form.get('job_id').dirty || jobs_timesheet_form.get('job_id').touched || jobs_timesheet_form.submitted)">
                        <small class="alert-danger" *ngIf="jobs_timesheet_form.get('job_id').errors?.required">
                            {{translate_service.getText('message_25')}}
                        </small>
                        <small class="alert-danger" *ngIf="jobs_timesheet_form.get('job_id').errors?.incorrect">
                            {{error_message}}
                        </small>
                    </span>
                </div>
                <div class="field mb-4 col-12 md:col-12">
                    <label>{{shared_service.account_task_heading}}<span class="asterisk"> *</span></label>
                    <p-dropdown optionValue="job_task_id" optionLabel="display_name" formControlName="job_task_id"
                        [resetFilterOnHide]="true" (onChange)="rateChange($event)" appendTo="body"
                        [ngClass]="{'is-invalid':jobs_timesheet_form.get('job_task_id').invalid && 
                        (jobs_timesheet_form.get('job_task_id').touched || jobs_timesheet_form.get('job_task_id').dirty || jobs_timesheet_form.submitted)}" [options]="job_task_list"
                        placeholder="{{translate_service.getText('lbl_select')}} {{shared_service.account_task_heading}}"
                        [filter]="true">
                        <ng-template let-option pTemplate="item">
                            <div pTooltip="{{ option.display_name}}" tooltipPosition="top">
                                {{
                                option.display_name.length > 30
                                ? option.display_name.slice(0, 30) + '...'
                                : option.display_name
                                }}
                            </div>
                        </ng-template>
                        <ng-template let-selectedOption pTemplate="selectedItem">
                            <div pTooltip="{{ selectedOption?.display_name }}"
                                tooltipPosition="top">
                                {{
                                selectedOption?.display_name?.length > 30
                                ? selectedOption.display_name.slice(0, 30) + '...'
                                : selectedOption?.display_name
                                }}
                            </div>
                        </ng-template>
                    </p-dropdown>
                    <span
                        *ngIf="jobs_timesheet_form.get('job_task_id').invalid && (jobs_timesheet_form.get('job_task_id').dirty ||jobs_timesheet_form.get('job_task_id').touched ||jobs_timesheet_form.submitted )">
                        <small class="alert-danger"
                            *ngIf="jobs_timesheet_form.get('job_task_id').errors?.required">{{translate_service.getText('message_25')}}</small>
                        <small class="alert-danger"
                            *ngIf="jobs_timesheet_form.get('job_task_id').errors?.incorrect">{{error_message
                            }}</small>
                    </span>
                </div>
                <div class="field mb-4 col-12 md:col-12">
                    <label>{{translate_service.getText('lbl_time')}}<span class="asterisk"> *</span></label>
                    <input maxlength="9" autocomplete="off" class="form-control" pKeyFilter="num" (blur)="validateAndConvertTime()"
                        [ngClass]="{'is-invalid':jobs_timesheet_form.get('estimated_time').invalid && 
                        (jobs_timesheet_form.get('estimated_time').touched || jobs_timesheet_form.get('estimated_time').dirty || jobs_timesheet_form.submitted)}"
                        formControlName="estimated_time" pInputText>
                    <span
                        *ngIf="jobs_timesheet_form.get('estimated_time').invalid && (jobs_timesheet_form.get('estimated_time').dirty ||jobs_timesheet_form.get('estimated_time').touched ||jobs_timesheet_form.submitted )">
                        <small class="alert-danger"
                            *ngIf="jobs_timesheet_form.get('estimated_time').errors?.required">{{translate_service.getText('message_25')}}</small>
                        <small class="alert-danger"
                            *ngIf="jobs_timesheet_form.get('estimated_time').errors?.incorrect">{{error_message
                            }}</small>
                    </span>
                </div>
                <div class="field mb-4 col-12 md:col-12">
                    <label class="font-medium text-900">{{translate_service.getText('lbl_rate_source')}}<span
                            class="asterisk">*</span></label>
                    <p-dropdown optionValue="timesheet_rate_source_id" optionLabel="name"
                        formControlName="rate_source_id" appendTo="body" [options]="rate_source_list"
                        (onChange)="rateChange($event,true)"
                        placeholder="{{translate_service.getText('lbl_select_rate_source')}}" [filter]="true"
                        dropzone="true" [ngClass]="{
                              'is-invalid': jobs_timesheet_form.get('rate_source_id').invalid && (jobs_timesheet_form.get('rate_source_id').dirty || jobs_timesheet_form.get('rate_source_id').touched),
                      }"></p-dropdown>

                    <span
                        *ngIf="jobs_timesheet_form.get('rate_source_id').invalid && (jobs_timesheet_form.get('rate_source_id').dirty || jobs_timesheet_form.get('rate_source_id').touched || jobs_timesheet_form.submitted)">
                        <small class="alert-danger"
                            *ngIf="jobs_timesheet_form.get('rate_source_id').errors?.required">{{translate_service.getText('message_25')}}</small>
                        <small class="alert-danger"
                            *ngIf="jobs_timesheet_form.get('rate_source_id').errors?.incorrect">{{error_message
                            }}</small>
                    </span>
                </div>
                <div class="field mb-2 col-12 hourly-rate-container"
                    *ngIf="jobs_timesheet_form.get('rate_source_id').value">
                    <div class="rate-input-container">
                        <div>
                            <label class="font-medium text-900 mr-1">{{translate_service.getText('lbl_base_rate')}}
                                :</label>
                            <span [ngClass]="{'strike-out': jobs_timesheet_form.get('rate_source_id').value == 1}"
                                class="rate-amount">{{base_rate | currency: shared_service.iso_code :
                                shared_service.currency_symbol : shared_service.decimal_code
                                :shared_service.iso_locale}}</span>

                            <p-inputNumber formControlName="base_rate" placeholder="Enter Manual Rate"
                                styleClass="w-9rem mt-2" [minFractionDigits]="shared_service.maxFractionDigits"
                                [maxFractionDigits]="shared_service.maxFractionDigits" mode="currency"
                                [currency]="shared_service.iso_code" [locale]="shared_service.iso_locale" />
                        </div>
                        <div>
                            <label class="font-medium text-900 mr-1">{{translate_service.getText('lbl_billable_rate')}}
                                :</label>
                            <span [ngClass]="{'strike-out': jobs_timesheet_form.get('rate_source_id').value == 1}"
                                class="rate-amount">{{billable_rate | currency: shared_service.iso_code :
                                shared_service.currency_symbol : shared_service.decimal_code
                                :shared_service.iso_locale}}</span>

                            <p-inputNumber formControlName="billable_rate" placeholder="Enter Manual Rate"
                                styleClass="w-10rem mt-2" [minFractionDigits]="shared_service.maxFractionDigits"
                                [maxFractionDigits]="shared_service.maxFractionDigits" mode="currency"
                                [currency]="shared_service.iso_code" [locale]="shared_service.iso_locale" />
                        </div>
                    </div>
                </div>
                <div class="field mb-4 col-12 md:col-12">
                    <label>{{translate_service.getText('lbl_notes')}}</label>
                    <textarea [placeholder]="translate_service.getText('lbl_notes')" formControlName="notes" type="text"
                        pInputTextarea rows="5" [autoResize]="true"></textarea>
                        <span>
                            <small class="alert-danger"
                            *ngIf="jobs_timesheet_form.get('notes').errors?.incorrect">{{error_message
                            }}</small>
                        </span>
                </div>
                <div class="field mb-4 col-12 md:col-12">
                    <div class="field-checkbox">
                        <p-checkbox formControlName="is_billable" [binary]="true"></p-checkbox>
                        <label>{{translate_service.getText('lbl_billable')}}</label>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <form class="grid" [formGroup]="job_timesheet_custom_fields_form">
        <div class="col-12" *ngIf="custom_fields.length > 0">
            <div class="text-900 font-medium text-xl">
                {{translate_service.getText('lbl_custom_fields')}}
            </div>
        </div>

        <div class="col-12">
            <div class="grid formgrid p-fluid">
                <ng-container *ngFor="let custom_field of custom_fields; let i = index;">
                    <div class="field mb-4 col-12 md:col-12">
                        <div [ngSwitch]="custom_field.custom_field_type_id">
                            <div *ngSwitchCase="customFields.Text">
                                <app-custom-textbox [customField]="custom_field" formControlName="customFieldText"
                                    [editCustomFieldList]="editCustomFieldList" [formsMode]="form_mode"
                                    [submit]="job_timesheet_custom_fields_form.submitted"
                                    (isRequiredChange)="onIsRequiredChange($event,custom_field.custom_field_id)"
                                    (textChange)="onTextChange($event)"></app-custom-textbox>
                            </div>
                            <div *ngSwitchCase="customFields.MultilineText">
                                <app-custom-textbox [customField]="custom_field"
                                    [editCustomFieldList]="editCustomFieldList" [formsMode]="form_mode"
                                    formControlName="customFieldParagraph" (textChange)="onParaChange($event)"
                                    [submit]="job_timesheet_custom_fields_form.submitted"
                                    (isRequiredChange)="onIsRequiredChange($event,custom_field.custom_field_id)"></app-custom-textbox>
                            </div>
                            <div *ngSwitchCase="customFields.Date">
                                <app-custom-date [customField]="custom_field" formControlName="customFieldDate"
                                    (textChange)="onDateChange($event)" [editCustomFieldList]="editCustomFieldList"
                                    [formsMode]="form_mode"
                                    (isRequiredChange)="onIsRequiredChange($event,custom_field.custom_field_id)"
                                    [submit]="job_timesheet_custom_fields_form.submitted"></app-custom-date>
                            </div>
                            <div *ngSwitchCase="customFields.Link">
                                <app-custom-link [customField]="custom_field" formControlName="customFieldLink"
                                    (textChange)="onWebsiteChange($event)" [editCustomFieldList]="editCustomFieldList"
                                    [formsMode]="form_mode" [submit]="job_timesheet_custom_fields_form.submitted"
                                    (isRequiredChange)="onIsRequiredChange($event,custom_field.custom_field_id)"></app-custom-link>
                            </div>
                            <div *ngSwitchCase="customFields.Number">
                                <app-custom-number [customField]="custom_field" formControlName="customFieldNumber"
                                    (textChange)="onNumberChange($event)" [editCustomFieldList]="editCustomFieldList"
                                    [formsMode]="form_mode" [submit]="job_timesheet_custom_fields_form.submitted"
                                    (isRequiredChange)="onIsRequiredChange($event,custom_field.custom_field_id)"></app-custom-number>
                            </div>
                            <div *ngSwitchCase="customFields.List">
                                <app-custom-list [customField]="custom_field" formControlName="customFieldList"
                                    [formsMode]="form_mode" (textChange)="onListChange($event)"
                                    [editCustomFieldList]="editCustomFieldList"
                                    (isRequiredChange)="onIsRequiredChange($event,custom_field.custom_field_id)"
                                    [submit]="job_timesheet_custom_fields_form.submitted"></app-custom-list>
                            </div>
                            <div *ngSwitchCase="customFields.RadioButton">
                                <app-custom-radio-button [customField]="custom_field" formControlName="customFieldRadio"
                                    [formsMode]="form_mode" (textChange)="onRadioChange($event)"
                                    [editCustomFieldList]="editCustomFieldList"
                                    (isRequiredChange)="onIsRequiredChange($event,custom_field.custom_field_id)"
                                    [submit]="job_timesheet_custom_fields_form.submitted"></app-custom-radio-button>
                            </div>
                            <div *ngSwitchCase="customFields.SingleCheckBox">
                                <app-custom-single-checkbox [customField]="custom_field"
                                    formControlName="customFieldCheckbox" (textChange)="onCheckboxChange($event)"
                                    [editCustomFieldList]="editCustomFieldList" [formsMode]="form_mode"
                                    (isRequiredChange)="onIsRequiredChange($event,custom_field.custom_field_id)"
                                    [submit]="job_timesheet_custom_fields_form.submitted"></app-custom-single-checkbox>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </form>

    <div class="flex gap-2 justify-content-end">
        <button type="button" pButton pRipple icon="pi pi-trash" label="{{translate_service.getText('lbl_delete')}}"
            class="p-element p-ripple p-button-danger p-button-outlined mr-2 p-button p-component" (click)="onDelete()"
            *ngIf="this.form_mode == this.formMode.Edit"
            [disabled]="common_service.permissionCheck(this.modules.collaboration,this.subModules.timesheet).canDelete || common_service.permissionCheck(this.modules.interactions,this.subModules.clients).canDelete"></button>
        <button pButton pRipple type="button" icon="pi pi-times" label="Cancel"
            class="p-element p-ripple p-button-outlined mr-2 p-button" (click)="onCancel('')"></button>
        <button pButton pRipple label="Save" icon="pi pi-check" type="submit"
            [disabled]="timesheet_details?.is_invoiced || timesheet_details?.is_task_completed || common_service.permissionCheck(this.modules.collaboration,this.subModules.timesheet).canView || common_service.permissionCheck(this.modules.interactions,this.subModules.clients).canView"
            class="p-element p-ripple p-button-primary  p-button" (click)="onSave()"></button>
    </div>
</div>